import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      isAgency: (state) =>
        state.user.type === 'agency' ||
        (state.user.parent_user != null && state.user.parent_user.slug == 'agency' && state.user.type === 'employee'),
      isEmployee: (state) => state.user.type === 'employee',
      isAgencyClient: (state) => state.user.type === 'agency-client',
      isBrandEmployee: (state) => state.user.type === 'brand-employee',
    }),
  },
  methods: {
hasElevatedPermissions() {
  const userType = this.$store?.getters['user/type']
  const isImpersonate = this.$store?.getters['user/is_impersonate']
  const impersonateUserType = this.$store?.getters['user/impersonate_user_type']

  return ['admin', 'pm', 'project-manager'].includes(userType) || 
         (isImpersonate && ['admin', 'pm', 'project-manager'].includes(impersonateUserType))
},

    // CAMPAIGNS
    canCreateCampaign(user) {
      //todo: implement limits
      if (user) return true
      return false
    },
    canEditCampaignData(campaign) {
      // Allow elevated permissions (Admin, PM, Impersonate) to bypass restrictions
      if (this.hasElevatedPermissions()) {
        return true
      }

      //reviewed and accepted, ready, running or completed
      if ([1, 2, 3, 5].includes(campaign.status)) {
        return false
      }
      //in review, not editable by agency
      if (campaign.is_owner && campaign.status === 4) {
        return false
      }
      //in draft, not editable by client
      // if (!campaign.is_owner && campaign.status === 0) {
      //   return false
      // }

      if (this.isBrandEmployee && (campaign.is_assigned || campaign.is_owner)) {
        return true
      }
      return true
    },
    canDeleteCampaignData(campaign) {
      // Allow elevated permissions (Admin, PM, Impersonate) to bypass restrictions
      if (this.hasElevatedPermissions()) {
        return true
      }

      //reviewed and accepted, ready, running or completed
      if ([1, 2, 3, 5].includes(campaign.status)) {
        return false
      }
      //in review, not editable by agency
      if (campaign.is_owner && campaign.status === 4) {
        return false
      }
      //in draft, not editable by client
      if (!campaign.is_owner && campaign.status === 0) {
        return false
      }
      // Brand Admin/Employee cannot delete campaigns they don't own (created by AA/AE)
      if (this.isAgencyClient && !campaign.is_owner) {
        return false
      }
      return true
    },
    // BRIEFS
    canCreateBrief(campaign) {
      // Allow elevated permissions (Admin, PM, Impersonate) to bypass restrictions
      if (this.hasElevatedPermissions()) {
        return true
      }

      if (this.isAgency && campaign.is_assigned && campaign.is_owner) {
        return [0, 1, 2].includes(campaign.status)
      }
      if (this.isAgencyClient && !campaign.is_owner) {
        return [1, 2, 4].includes(campaign.status)
      }
      return this.canAlter(campaign)
    },
    canEditBrief(campaign, brief) {
      // Allow elevated permissions (Admin, PM, Impersonate) to bypass restrictions
      if (this.hasElevatedPermissions()) {
        return true
      }

      if ([1, 2].includes(campaign.status)) {
        return brief.creators_accepted_count === 0
      }

      if (this.isBrandEmployee && (campaign.is_owner || campaign.is_assigned)) {
        return campaign?.status === 0
      }
      return this.canAlter(campaign)
    },
    canDeleteBrief(campaign, brief) {
      // Allow elevated permissions (Admin, PM, Impersonate) to bypass restrictions
      if (this.hasElevatedPermissions()) {
        return true
      }

      if ([1, 2].includes(campaign.status)) {
        return brief.creators_accepted_count === 0
      }
      return this.canAlter(campaign)
    },
    // GROUPS
    canCreateGroup(campaign) {
      if (this.hasElevatedPermissions()) {
        return true
      }

      if (this.isAgency && campaign.is_assigned && campaign.is_owner) {
        return [0, 1, 2].includes(campaign.status)
      } else if (this.isAgencyClient && !campaign.is_owner) {
        return [1, 2, 4].includes(campaign.status)
      } else return this.canAlter(campaign)
    },
    canEditGroup(campaign, group) {
      // Allow elevated permissions (Admin, PM, Impersonate) to bypass restrictions
      if (this.hasElevatedPermissions()) {
        return true
      }

      if ([1, 2].includes(campaign.status)) {
        return group.creators_accepted_count === 0
      }
      if (this.isBrandEmployee && (campaign.is_owner || campaign.is_assigned)) {
        return campaign?.status === 0
      }
      return this.canAlter(campaign)
    },
    canLink(campaign) {
      if (this.hasElevatedPermissions()) {
        return true
      }

      if ([1, 2].includes(campaign.status)) {
        return true
      }
      return this.canAlter(campaign)
    },
    canDeleteGroup(campaign, group) {
      if (this.hasElevatedPermissions()) {
        return true
      }

      if ([1, 2].includes(campaign.status)) {
        return group.creators_accepted_count === 0
      }
      return this.canAlter(campaign)
    },
    // LINKS
    canEditLinks(campaign) {
      if (this.hasElevatedPermissions()) {
        return true
      }

      if ([1, 2].includes(campaign.status)) {
        return true
      }
      return this.canAlter(campaign)
    },
    canDeleteLink(campaign, group_brief) {
      if (this.hasElevatedPermissions()) {
        return true
      }

      if ([1, 2].includes(campaign.status)) {
        return group_brief.creators_count === 0
      }
      return this.canAlter(campaign)
    },
    canAlterCreators(campaign) {
      // Allow elevated permissions (Admin, PM, Impersonate) to bypass restrictions
      if (this.hasElevatedPermissions()) {
        return true
      }

      if ([1, 2].includes(campaign?.status || -1)) {
        return true
      }
      return this.canAlter(campaign)
    },

    canAlter(campaign) {
      if (this.hasElevatedPermissions()) {
        return true
      }

      if (campaign?.is_owner) {
        if (this.isAgency) {
          if (campaign.is_assigned) {
            return campaign.status === 0
          } else {
            return campaign.status !== 3
          }
        }
        // Brand Admin/Employee owns the campaign
        return campaign.status !== 3
      } else {
        // Not the owner
        if (this.isAgency) {
          // Agency can alter campaigns in Active/Scheduled status
          return [1, 2].includes(campaign?.status || -1)
        }
        if (this.isAgencyClient) {
          // Brand Admin/Employee can only alter in "In Review" status
          return campaign?.status === 4
        }

        return false
      }
    },
    addSingleCreator(profile, index) {
      this.$confirm('Are you sure do you want to add this creator to this group?', 'Add creator to group!', {
        confirmButtonText: 'Add to group',
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          try {
            await this.axios.post('/api/campaign/' + this.$route.params.id + '/group/' + this.$route.params.group_id + '/add-to-group', {
              creator_id: profile.id,
            })
            this.data.creators_added += 1
            this.data.creators_notadded -= 1
            this.profiles.splice(index, 1)
            this.$store.commit('campaigns/SET_CREATORS_ADDED', this.data.creators_added)
          } catch (e) {
            console.warn(e.message)
          }
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: 'info',
            message: this.$t('cancel_add'),
          })
        })
    },
    async addBulkCreators(ids) {
      const selectedPositions = ids.reduce((acc, profileId) => {
        const position = this.profiles.findIndex((profile) => profile.id === profileId)
        if (position !== -1) {
          acc[position] = profileId
        }
        return acc
      }, {})

      try {
        await this.axios.post('/api/campaign/' + this.$route.params.id + '/group/' + this.$route.params.group_id + '/add-bulk-to-group', {
          creator_ids: ids,
        })
        this.data.creators_added += ids.length
        this.data.creators_notadded -= ids.length
        Object.keys(selectedPositions)
          .sort((a, b) => b - a)
          .forEach((index) => {
            this.profiles.splice(index, 1)
          })
      } catch (e) {
        console.warn(e.message)
      }
    },
  },
}